<span *ngIf="!wasCurated; else curated">
  <span *ngIf="aberration?.manualCurationStatus?.partiallyCurated; then partiallyCurated else notCurated"></span>
</span>

<ng-template #curated>
  <span translate>aberration.curated</span>
  <span>({{ aberration?.manualCurationStatus?.lastCurationDate  | date: 'd MMM yyyy' }})</span>
</ng-template>

<ng-template #notCurated>
  <span translate>aberration.not_curated</span>
</ng-template>

<ng-template #partiallyCurated>
  <i class="icon icon__dls-link-grey link-icon"></i>
  <span translate>aberration.partial_curation</span>
</ng-template>